import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import idGenerator from 'react-id-generator'
import classNames from 'classnames'
import { Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'

// Lets import styles for component
import './VideoModal.sass'

// Lets import images
import download from '../../img/download.svg'
import dropdown from '../../img/dropdown.svg'
import close from '../../img/close.svg'

export default class VideoModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      selectedLang: '',
      video: {},
      downloadsDropDown: false,
    }
  }

  componentDidMount = () => {
    const { video } = this.props
    if (video) {
      document.body.classList.add('noscroll')
      this.setState(prevState => {
        return {
          open: !prevState.open,
          selectedLang: video.activeVideo.lang,
          video,
        }
      })
    }
  }

  componentWillUnmount = () => {
    document.body.classList.remove('noscroll')
  }

  openDownloadDropDown = () => {
    this.setState(prevState => {
      return {
        downloadsDropDown: !prevState.downloadsDropDown
      }
    })
  }
  
  render() {
    const { selectedLang, downloadsDropDown} = this.state
    const { video, t, l } = this.props;
    return (
      <div>
        <div className="videoModal">
          <div className="modalContent">
            <Link to={`/${l.i18n.language}/`} className="closeModal">
              <img src={close} alt="close"/>
            </Link>
            <div className="container">
              <div className="body">
                <div className="flexWrap">
                  <div className="left">
                    {video.activeVideo ? (
                      <>
                        {video.activeVideo.thumbnail ? (
                          <BackgroundImage Tag="div"
                            className="imageWrap"
                            fluid={video.activeVideo.thumbnail.childImageSharp.fluid}
                          >
                            <ReactPlayer
                              className="player"
                              url={video.activeVideo.url}
                              width="100%"
                              height="100%"
                              controls
                            />
                          </BackgroundImage> 
                        ) : null}                       
                        <div className="title">
                          {video.activeVideo.title}
                        </div>
                        <span className="label">
                          {video.activeVideo.country}
                        </span>
                      </>
                    ) : null}
                    {video.selectedVideos ? (
                      <div className="mobileSwitcher">
                        <div className={classNames({
                        languagesWrap: true,
                        onlyOne: video.selectedVideos.length === 1
                      })}>
                          {video.selectedVideos.map(item => {
                            return (
                              <Link
                                to={`/${l.i18n.language}/${item.slug}`}
                                className={classNames({
                                  langButton: true,
                                  active: selectedLang === item.lang
                                })} 
                                key={idGenerator()}
                              >
                                {item.lang}
                              </Link>
                            )
                          })}
                        </div>
                        {video.activeVideo.downloads ? (
                            <div className="downloadsList">
                              <button
                                  type="button"
                                  aria-label={t('video_modal_download')}
                                  onClick={this.openDownloadDropDown}
                                  className={
                                    classNames({
                                      downloadsDropDown: true,
                                      open: downloadsDropDown
                                    })
                                  }>
                                {t('video_modal_download')}
                                <img src={dropdown} alt="dropdown"/>
                              </button>
                              <ul className={
                                classNames({
                                  dropDownList: true,
                                  show: downloadsDropDown
                                })
                              }>
                                { video.activeVideo.downloads.map(item => {
                                return (
                                <li key={idGenerator()}>
                                <a
                                href={item.url}
                                aria-label="download icon"
                                >
                                {t(`${item.title.toLowerCase()}`)}
                                <img src={download} alt="download"/>
                                </a>
                                </li>
                                )
                              })}
                              </ul>
                            </div>
                        ) : null}
                      </div>
                    ) : null}
                  {video.activeVideo ? (
                    <div className="description">
                      {video.activeVideo.description}
                    </div>
                  ) : null}
                  </div>
                  <div className="right">
                    {video.selectedVideos ? (
                      <div className={classNames({
                        languagesWrap: true,
                        onlyOne: video.selectedVideos.length === 1
                      })}>
                        {video.selectedVideos.map(item => {
                          return (
                            <Link
                              to={`/${l.i18n.language}/${item.slug}`}
                              className={classNames({
                                langButton: true,
                                active: selectedLang === item.lang
                              })} 
                              key={idGenerator()}
                            >
                              {t(`${item.lang.toLowerCase()}`)}
                            </Link>
                          )
                        })}
                      </div>
                    ) : null}
                    {video.activeVideo.downloads ? (
                      <div className="downloadsList">
                        <button
                          type="button"
                          aria-label={t('video_modal_download')}
                          onClick={this.openDownloadDropDown} 
                          className={
                            classNames({
                              downloadsDropDown: true,
                              open: downloadsDropDown
                            })
                          }>
                          {t('video_modal_download')}
                          <img src={dropdown} alt="dropdown"/>
                        </button>
                        <ul className={
                          classNames({
                            dropDownList: true,
                            show: downloadsDropDown
                          })
                        }>
                          {video.activeVideo.downloads.map(item => {
                            return (
                              <li key={idGenerator()}>
                                <a 
                                  href={item.url}
                                  aria-label="icon download"
                                  download  
                                >
                                  {t(`${item.title.toLowerCase()}`)}
                                  <img src={download} alt="download"/>
                                </a>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
